const organization = {
    require_membership: '用户必须是组织的成员才能继续。',
    role_names_not_found: '检测到无效的角色名称：{{names,list(type:conjunction)}}。请先创建这些角色，然后再继续。',
};
export default Object.freeze(organization);
